<section class="change-password-section">
    <header class="row page-header margin-0">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h2 class= title>reset your password</h2>
                </div>
            </div>
        </div>
    </header>
    <main>
        <form [formGroup]="pageForm">
            <div class="form-section">
                <div class="container">
                    <div class="form-section-container">
                        <div class="row top-buffer-20 feedback-container">
                            <div class="col-md-6 offset-md-2">
                                <div class="alert alert-success" role="alert" *ngIf="successMessage != ''">
                                    <span class="glyphicon glyphicon-ok" aria-hidden="true"></span> {{ successMessage }}
                                </div>
                                <div class="alert alert-danger" role="alert" *ngIf="feedbackMessages.length > 0">
                                    <div *ngFor="let msg of feedbackMessages">
                                        <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                                        <span class="visually-hidden">Error:</span> {{ msg.details }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row top-buffer-20" *ngIf="isResetComplete">
                            <div class="col-md-4">
                                <label>
                                    <a [routerLink]="['/signin']" class="reset-button">Back to Sign In</a>
                                </label>
                            </div>
                        </div>

                        <div class="row top-buffer-20" *ngIf="!isResetComplete">
                            <div class="col-md-2">
                                <label for="email">Email</label><span class="red">*</span>
                            </div>
                            <div class="col-md-5">
                                <input type="email" class="form-control" formControlName="email" placeholder="Email" maxlength="50" required />
                                <sp-field-error [controlName]="'Email'" [control]="pageForm?.controls?.email"></sp-field-error>
                            </div>
                        </div>
                        <div class="row top-buffer-20" *ngIf="!isResetComplete">
                            <div class="col-md-2">
                                <label>New Password</label><span class="red">*</span>
                            </div>
                            <div class="col-md-5">
                                <input type="password" class="form-control" formControlName="newPassword" placeholder="New Password" maxlength="20" #newPassword
                                       required />
                                <sp-field-error [controlName]="'New Password'" [control]="pageForm?.controls?.newPassword"></sp-field-error>
                            </div>
                            <div class="col-md-2">
                                <a class="showMyTyping" (click)="showCurrentPassword($event)">{{ showTypingText }}</a>
                            </div>
                            <div class="col-md-3">
                                <ol class="password-hint">
                                    <li>
                                        Passwords must have at least six characters that includes: lowercase letters, numbers,
                                        and symbols.
                                    </li>
                                </ol>
                            </div>
                        </div>
                        <div class="row top-buffer-20" *ngIf="!isResetComplete">
                            <div class="col-md-2">
                                <label>Confirm Password</label><span class="red">*</span>
                            </div>
                            <div class="col-md-5">
                                <input type="password" class="form-control" formControlName="confirmPassword" placeholder="Confirm Password" maxlength="20"
                                       required />
                                <sp-field-error [controlName]="'Confirm Password'" [control]="pageForm?.controls?.confirmPassword"></sp-field-error>
                            </div>
                        </div>
                        <div class="row top-buffer-20" *ngIf="!isResetComplete">
                            <div class="col-md-9 offset-md-2">
                                <button [disabled]="!pageForm?.valid || isResetingPassword" type="submit" (click)="onResetPassword()" class="btn btn-success btn-change-password">
                                    <span *ngIf="isResetingPassword" class="sp-icon-loader-button-secondary u-alignMiddle"></span>
                                    reset password
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </main>
</section>
